import styled, { css } from "styled-components";
// import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';

const center = css`
  display: flex;
  /* align-items: center; */
`;

export const Wrap = styled.div`
  ${center}
  flex-direction: column;
`;
